import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AdjusterDto} from "../../../../../auto-generated-server-dtos/adjuster/claim/assign-to/adjuster-dto";
import {environment} from "../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ListAdjustersService {
  constructor(private httpClient: HttpClient) {
  }

  listAdjusters() {
    return this.httpClient.get<AdjusterDto[]>(`${environment.apiServer}/Adjuster/ListAdjusters`);
  }
}
